import React, { useMemo, useState } from "react";
import {
    Tabs,
    Tab,
    Typography,
    Paper
} from "@material-ui/core";

function safeParseTranslations(raw) {
    if (!raw || typeof raw !== "string") return [];

    let text = raw.trim();

    if (text.startsWith("```")) {
        const lines = text.split(/\r?\n/);
        lines.shift();

        if (
            lines.length > 0 &&
            lines[lines.length - 1].trim().startsWith("```")
        ) {
            lines.pop();
        }

        text = lines.join("\n").trim();
    }

    const first = text.indexOf("[");
    const last = text.lastIndexOf("]");

    if (first !== -1 && last > first) {
        text = text.substring(first, last + 1);
    }

    try {
        const parsed = JSON.parse(text);
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        console.warn("TranslationsJson konnte nicht gelesen werden:", error);
        return [];
    }
}

const languageNames = {
    de: "Deutsch",
    en: "English",
    fr: "Français",
    es: "Español",
    uk: "Ukrainisch",
    tr: "Türkisch"
};

export default function NewsTranslations({ translationsJson }) {
    const translations = useMemo(
        () => safeParseTranslations(translationsJson),
        [translationsJson]
    );

    const [activeTab, setActiveTab] = useState(0);

    if (translations.length === 0) {
        return (
            <Typography variant="body2">
                Keine Übersetzungen vorhanden.
            </Typography>
        );
    }

    const selected =
        translations[activeTab] ?? translations[0];

    return (
        <div>
            <Tabs
                value={Math.min(activeTab, translations.length - 1)}
                onChange={(_, value) => setActiveTab(value)}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
            >
                {translations.map((translation, index) => (
                    <Tab
                        key={`${translation.lang}-${index}`}
                        label={languageNames[translation.lang] ?? translation.lang}
                    />
                ))}
            </Tabs>

            <Paper
                elevation={0}
                style={{
                    marginTop: 12,
                    padding: 16,
                    background: "#f7f8fa"
                }}
            >
                <Typography variant="h6" style={{ marginBottom: 10 }}>
                    {selected.title || "Ohne Titel"}
                </Typography>

                <Typography
                    variant="body1"
                    style={{
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.65
                    }}
                >
                    {selected.summary || "Keine Zusammenfassung vorhanden."}
                </Typography>
            </Paper>
        </div>
    );
}